import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Image, Input, notification } from 'antd'
import { useState } from 'react'
import AddProductCart from '../../../services/addProductCart.service'
import { formatPriceByUnit } from '../../../utils/stringUtils'
import { extractValidUrl, Marketplace } from './handleUrl'
import { isEmpty } from 'lodash'

const Product1688 = ({ product, loadData, t, link, handleClear }: any) => {
    const [quantity, setQuantity] = useState<{ [skuId: string]: number }>({})
    const [loading, setLoading] = useState(false)
    const stepQuantity = product?.batchNumber || 1

    const handleIncrease = (skuId: string) => {
        setQuantity(prevQuantities => {
            const newQuantities = { ...prevQuantities }
            newQuantities[skuId] = (newQuantities[skuId] || 0) + stepQuantity
            return newQuantities
        })
    }

    const handleDecrease = (skuId: string) => {
        setQuantity(prevQuantities => {
            const newQuantities = { ...prevQuantities }
            newQuantities[skuId] = Math.max((newQuantities[skuId] || 0) - stepQuantity, 0)
            return newQuantities
        })
    }

    const handleInputChange = (skuId: string, value: number) => {
        setQuantity(prevQuantities => {
            const newQuantities = { ...prevQuantities }
            newQuantities[skuId] = value > 9999 ? 9999 : Math.max(value, 0)
            return newQuantities
        })
    }

    const getOriginalPrice = (priceRangeList: any, quantity: number, skuId?: string) => {
        let originalPrice = 0
        priceRangeList?.forEach((range: any) => {
            if (range?.startQuantity <= quantity) {
                originalPrice = range?.promotionPrice || range?.price
            }
        })
        if (originalPrice === 0 && skuId) {
            const skuPrice = product?.productSkuInfos?.find((item: any) => item?.skuId === skuId)?.consignPrice
            originalPrice = skuPrice
        }
        if (originalPrice === 0 && !skuId && !isEmpty(priceRangeList)) {
            originalPrice = priceRangeList?.[0]?.price
        }
        return originalPrice
    }

    const handleAddToCart = () => {
        let selectedItems: any = []
        if (product?.skus && product?.skus?.length > 0) {
            selectedItems = product?.skus
                ?.filter((sku: any) => quantity[sku?.skuId] > 0) // Lọc ra những SKU có quantity > 0
                ?.map((sku: any) => {
                    const url = extractValidUrl(link)
                    return {
                        name: product?.title || product?.subject,
                        originalName: product?.title || product?.subject,
                        originalPrice: (sku?.salePrice || 0) / 100,
                        salePrice: (sku?.salePrice || 0) / 100,
                        pricePolicy: [],
                        currency: 'CNY',
                        merchant: {
                            id: product?.merchant?.id || product?.shopId || 'shop',
                            name: product?.merchant?.name || product?.shopName || 'shop',
                            marketplace: product?.merchant?.marketplace || product?.marketplace || (product?.type === Marketplace.Taobao ? 'taobao' : '1688'),
                        },
                        image: product?.productImages?.[0] || product?.mainImageUrl || product?.images?.[0] || '',
                        url: url,
                        variantImage: sku?.images?.[0] || product?.productImages?.[0] || product?.mainImageUrl || '',
                        variantProperties: sku?.variantProperties?.map((attr: any) => ({
                            id: attr?.id || attr?.value,
                            originalName: attr?.originalName || attr?.name || attr?.attributeName,
                            originalValue: attr?.originalValue || attr?.value,
                        })),
                        batchSize: 1,
                        quantity: quantity[sku?.skuId],
                        stock: sku?.stock ?? (product?.stock || 999),
                        originalId: product?.id || product?.oid || product?.miId,
                        minQuantity: product?.minOrderQuantity || 1,
                        skuId: sku?.skuId,
                        specId: sku?.specId || sku?.skuId,
                        brand: '',
                        totalRate: null,
                    }
                })
        } else if (product?.type === Marketplace.Alibaba) {
            if (product?.productSkuInfos === null) {
                selectedItems = [
                    {
                        name: product?.subject,
                        originalName: product?.subject,
                        originalPrice: getOriginalPrice(
                            product?.productSaleInfo?.priceRangeList,
                            quantity[product?.id],
                            product?.id
                        ),
                        salePrice: getOriginalPrice(product?.productSaleInfo?.priceRangeList, quantity[product?.id], product?.id),
                        pricePolicy: product?.productSaleInfo?.priceRangeList || [],
                        currency: 'CNY',
                        merchant: {
                            id: product?.sellerOpenId,
                            name: product?.sellerOpenId,
                            marketplace: '1688',
                        },
                        image: !isEmpty(product?.productImage?.images) ? product?.productImage?.images?.[0] : '',
                        url: link,
                        variantImage: !isEmpty(product?.productImage?.images) ? product?.productImage?.images?.[0] : '',
                        variantProperties: [],
                        batchSize: 1,
                        quantity: quantity[product?.id],
                        stock: 999, // api k trả về stock
                        originalId: product?.offerId,
                        minQuantity: product?.minOrderQuantity,
                        skuId: product?.id,
                        specId: product?.id,
                        brand: '',
                        totalRate: null,
                    },
                ]
            } else {
                const totalQuantity = Object.values(quantity)?.reduce((a, b) => a + b, 0)
                selectedItems = product?.productSkuInfos
                    ?.filter((sku: any) => quantity[sku?.skuId] > 0) // Lọc ra những SKU có quantity > 0
                    ?.map((sku: any) => {
                        const url = extractValidUrl(link)
                        const originPrice =
                            product?.productSaleInfo?.priceRangeList?.length > 1
                                ? getOriginalPrice(product?.productSaleInfo?.priceRangeList, totalQuantity, sku.skuId)
                                : stepQuantity > 1
                                    ? (sku?.price || +sku?.consignPrice)
                                    //  / stepQuantity
                                    : sku?.price || +sku?.consignPrice
                        return {
                            name: product?.subject,
                            originalName: product?.subject,
                            originalPrice: originPrice,
                            salePrice: originPrice,
                            pricePolicy:
                                product?.productSaleInfo?.priceRangeList?.length > 1
                                    ? product?.productSaleInfo?.priceRangeList
                                    : [],
                            currency: 'CNY',
                            merchant: {
                                id: product?.sellerOpenId,
                                name: product?.sellerOpenId,
                                marketplace: '1688',
                            },
                            image: !isEmpty(product?.productImage?.images)
                                ? product?.productImage?.images?.[0]
                                : product?.images?.[0] || product?.image || '',
                            url: url,
                            variantImage:
                                sku?.skuAttributes?.[0]?.skuImageUrl ||
                                product?.productImage?.images?.[0] ||
                                product?.images?.[0] ||
                                product?.image,
                            variantProperties: sku?.skuAttributes?.map((attr: any) => ({
                                id: attr?.value,
                                originalName: attr?.attributeName,
                                originalValue: attr?.value,
                            })),
                            batchSize: 1,
                            quantity: quantity[sku?.skuId],
                            stock: 999, // api k trả về stock
                            originalId: product?.offerId || product?.id,
                            minQuantity: product?.minOrderQuantity,
                            skuId: sku?.skuId,
                            specId: sku?.specId,
                            brand: '',
                            totalRate: null,
                        }
                    })
            }
        }

        const cartItems = { skus: selectedItems }

        setLoading(true)
        AddProductCart.addToCart(cartItems, (res: any) => {
            if (res && res?.code !== 204) {
                notification['error']({
                    message: t('message.error'),
                })
                setLoading(false)
            } else {
                loadData(handleClear())
                setLoading(false)
                notification['success']({
                    message: t('message.success'),
                })
                AddProductCart.trackingAddToCart()
            }
        })
    }

    const calculateTotal = () => {
        const totalQuantity = Object.values(quantity)?.reduce((acc, curr) => acc + curr, 0)
        if (product?.productSkuInfos === null) {
            return {
                totalQuantity: totalQuantity,
                totalPrice: getOriginalPrice(product?.productSaleInfo?.priceRangeList, totalQuantity) * totalQuantity,
            }
        }
        if (product?.productSkuInfos && product?.productSkuInfos?.length > 0) {
            return {
                totalQuantity: totalQuantity,
                totalPrice: getOriginalPrice(product?.productSaleInfo?.priceRangeList, totalQuantity) * totalQuantity,
            }
        } else if (product?.skus && product?.skus?.length > 0) {
            const selectedItems = product?.skus?.filter((sku: any) => quantity[sku?.skuId] > 0)
            const totalPrice = selectedItems?.reduce(
                (acc: number, item: any) =>
                    acc + (parseFloat(item?.salePrice || 0) / 100) * (quantity[item?.skuId] || 0),
                0
            )
            return { totalQuantity, totalPrice }
        } else {
            const selectedItems = product?.productSkuInfos?.filter((sku: any) => quantity[sku?.skuId] > 0)
            const totalPrice = selectedItems?.reduce(
                (acc: number, item: any) =>
                    acc + parseFloat(item?.consignPrice || item?.price || 0) * (quantity[item?.skuId] || 0),
                0
            )
            return { totalQuantity, totalPrice }
        }
    }

    const getPriceByQuantity = (totalQuantity: number, priceRangeList: any[]) => {
        if (!priceRangeList || priceRangeList.length === 0) return 0

        // Sắp xếp mảng theo số lượng tăng dần để lấy giá đúng
        const sortedRanges = [...priceRangeList]?.sort((a, b) => a?.startQuantity - b?.startQuantity)

        // Lấy giá tương ứng với số lượng tổng đã chọn
        let selectedPrice = sortedRanges?.[0]?.promotionPrice || sortedRanges?.[0]?.price
        for (const range of sortedRanges) {
            if (totalQuantity >= range?.startQuantity) {
                selectedPrice = range?.promotionPrice || range?.price
            }
        }

        return selectedPrice
    }

    // Tính tổng số lượng sản phẩm đã chọn
    const totalQuantity = Object.values(quantity).reduce((sum, q) => sum + q, 0)

    return (
        <div className="flex items-start justify-around space-x-4 mt-6">
            <Image
                src={
                    product?.productImage?.images?.[0] ||
                    product?.productImages?.[0] ||
                    product?.images?.[0] ||
                    product?.image
                }
                preview={false}
                className="max-w-[400px] !rounded"
                referrerPolicy='no-referrer'
            />
            <div>
                <div className="text-lg font-medium mb-3">{product?.subject || product?.title || product?.name}</div>
                <div
                    className={`flex flex-col gap-2 ${product?.productSkuInfos === null ? '' : 'h-[340px]'
                        } overflow-y-auto relative`}
                >
                    <div>
                        {product?.productSaleInfo?.priceRangeList?.length > 1 && (
                            <div className="flex items-center justify-between py-2 px-2">
                                {product?.productSaleInfo?.priceRangeList?.map((item: any) => {
                                    return (
                                        <div>
                                            <div>Số lượng từ: {item?.startQuantity}</div>
                                            <div>Giá: {formatPriceByUnit(item?.promotionPrice || item?.price, 'CNY')}</div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                        {product?.productSkuInfos?.map((sku: any) => {
                            return (
                                <div
                                    key={sku?.skuId}
                                    className="flex items-center gap-5 border-b border-grey-100 py-2 px-2 cursor-pointer"
                                >
                                    <div className="basis-3/5 flex items-center gap-2">
                                        {sku.skuAttributes?.[0]?.skuImageUrl && (
                                            <Image
                                                src={sku.skuAttributes?.[0]?.skuImageUrl}
                                                width={60}
                                                height={60}
                                                preview={false}
                                                className=""
                                                referrerPolicy='no-referrer'
                                            />
                                        )}
                                        <div className="flex flex-col gap-2 ">
                                            {!isEmpty(sku?.skuAttributes) ? sku?.skuAttributes?.map((attribute: any) => {
                                                return (
                                                    <div
                                                        key={attribute?.id}
                                                        className="flex items-center space-x-2"
                                                    >
                                                        <span className="whitespace-nowrap">{attribute?.attributeName}:</span>
                                                        <span className="line-clamp-1">{attribute?.value}</span>
                                                    </div>
                                                )
                                            }) : (
                                                <div
                                                    className="flex items-center space-x-2"
                                                >
                                                    <span className="whitespace-nowrap">Default</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="basis-1/5 text-center">
                                        {product?.productSaleInfo?.priceRangeList?.length > 1
                                            ? formatPriceByUnit(
                                                getPriceByQuantity(totalQuantity, product?.productSaleInfo?.priceRangeList),
                                                'CNY'
                                            )
                                            : formatPriceByUnit(stepQuantity > 1 ? sku?.price : sku?.price, 'CNY')}
                                    </div>
                                    <div
                                        className={
                                            'txt-secondary rounded-lg px-3 py-[1px] border border-solid border-[#C0C0C0] flex items-center basis-1/5'
                                        }
                                    >
                                        <span
                                            className="px-2 py-1 hover:cursor-pointer"
                                            onClick={() => handleDecrease(sku?.skuId)}
                                        >
                                            <MinusOutlined />
                                        </span>
                                        <Input
                                            value={quantity[sku?.skuId] || 0}
                                            onChange={e => {
                                                if (stepQuantity > 1) {
                                                    return
                                                }
                                                const value = e.target.value.replace(/[^\d]/g, '')
                                                handleInputChange(sku?.skuId, +value)
                                            }}
                                            style={{ textAlign: 'center', padding: '0 10px', width: '100px' }}
                                            bordered={false}
                                            max={9999}
                                        />
                                        <span
                                            className="px-2 py-1 hover:cursor-pointer"
                                            onClick={() => handleIncrease(sku?.skuId)}
                                        >
                                            <PlusOutlined />
                                        </span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    {product?.skus?.map((sku: any) => {
                        return (
                            <div
                                key={sku?.skuId}
                                className="flex items-center gap-5 border-b border-grey-100 py-2 px-2 cursor-pointer"
                            >
                                <div className="basis-3/5 flex items-center gap-2">
                                    {(sku?.images?.[0] || product?.mainImageUrl || product?.productImages?.[0]) && (
                                        <Image
                                            src={sku?.images?.[0] || product?.mainImageUrl || product?.productImages?.[0]}
                                            width={60}
                                            height={60}
                                            preview={false}
                                            className=""
                                            referrerPolicy='no-referrer'
                                        />
                                    )}
                                    <div className="flex flex-col gap-2 ">
                                        {!isEmpty(sku?.variantProperties) ? sku?.variantProperties?.map((attribute: any) => {
                                            return (
                                                <div
                                                    key={attribute?.id || attribute?.pId || attribute?.name}
                                                    className="flex items-center space-x-2"
                                                >
                                                    <span className="whitespace-nowrap">{attribute?.originalName || attribute?.name}:</span>
                                                    <span className="line-clamp-1">{attribute?.originalValue || attribute?.value}</span>
                                                </div>
                                            )
                                        }) : sku?.name ? (
                                            <div className="flex items-center space-x-2">
                                                <span className="line-clamp-1">{sku?.name}</span>
                                            </div>
                                        ) : (
                                            <div
                                                className="flex items-center space-x-2"
                                            >
                                                <span className="whitespace-nowrap">Default</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="basis-1/5 text-center">{formatPriceByUnit((sku?.salePrice || 0) / 100, 'CNY')}</div>
                                <div
                                    className={
                                        'txt-secondary rounded-lg px-3 py-[1px] border border-solid border-[#C0C0C0] flex items-center basis-1/5'
                                    }
                                >
                                    <span
                                        className="px-2 py-1 hover:cursor-pointer"
                                        onClick={() => handleDecrease(sku?.skuId)}
                                    >
                                        <MinusOutlined />
                                    </span>
                                    <Input
                                        value={quantity[sku?.skuId] || 0}
                                        onChange={e => {
                                            const value = e.target.value.replace(/[^\d]/g, '')
                                            handleInputChange(sku?.skuId, +value)
                                        }}
                                        style={{ textAlign: 'center', padding: '0 10px', width: '100px' }}
                                        bordered={false}
                                        max={9999}
                                    />
                                    <span
                                        className="px-2 py-1 hover:cursor-pointer"
                                        onClick={() => handleIncrease(sku?.skuId)}
                                    >
                                        <PlusOutlined />
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {product?.productSkuInfos === null && (
                    <>
                        <div className="flex items-center justify-between">
                            {product?.productSaleInfo?.priceRangeList?.map((item: any) => {
                                return (
                                    <div>
                                        <div>Số lượng từ: {item?.startQuantity}</div>
                                        <div>Giá: {formatPriceByUnit(item?.price, 'CNY')}</div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="mt-6 flex items-center justify-center">
                            <div
                                className={
                                    'txt-secondary w-fit rounded-lg px-3 py-[1px] border border-solid border-[#C0C0C0] flex items-center basis-1/5'
                                }
                            >
                                <span
                                    className="px-2 py-1 hover:cursor-pointer"
                                    onClick={() => handleDecrease(product?.id)}
                                >
                                    <MinusOutlined />
                                </span>
                                <Input
                                    value={quantity[product?.id] || 0}
                                    onChange={e => {
                                        const value = e.target.value.replace(/[^\d]/g, '')
                                        handleInputChange(product?.id, +value)
                                    }}
                                    style={{ textAlign: 'center', padding: '0 10px', width: '100px' }}
                                    bordered={false}
                                    max={9999}
                                />
                                <span
                                    className="px-2 py-1 hover:cursor-pointer"
                                    onClick={() => handleIncrease(product?.id)}
                                >
                                    <PlusOutlined />
                                </span>
                            </div>
                        </div>
                    </>
                )}
                <div className="flex items-start justify-between mt-6">
                    <span className="text-base flex flex-col items-start">
                        <span>Tổng số lượng: {calculateTotal()?.totalQuantity || 0} sản phẩm</span>{' '}
                        {stepQuantity && stepQuantity > 1 && (
                            <span className="text-[#faad14] mt-1 text-xs">{`Cần mua theo lô ${stepQuantity} sản phẩm`} </span>
                        )}

                    </span>
                    <div className='text-base flex flex-col items-end'>
                        <span className="text-base">Thành tiền: {formatPriceByUnit(calculateTotal()?.totalPrice || 0, 'CNY')}</span>
                        {product?.minOrderQuantity > 1 && (
                            <span className="text-red-500 mt-1 text-xs">{`Mua tối thiểu ${product?.minOrderQuantity} sản phẩm`}</span>
                        )}
                    </div>
                </div>
                <Button
                    // sticky bottom-[-10px] left-[53%]
                    className="w-full mt-3 btn--blue"
                    onClick={handleAddToCart}
                    loading={loading}
                    size="large"
                    disabled={
                        Object.entries(quantity).filter(([skuId, qty]) => qty > 0).length < 1 ||
                        calculateTotal()?.totalQuantity < product?.minOrderQuantity
                    }
                >
                    Thêm sản phẩm vào giỏ hàng
                </Button>
            </div>
        </div>
    )
}

export default Product1688
